import { render, staticRenderFns } from "./RobotBuilder.vue?vue&type=template&id=82750640&scoped=true&"
import script from "./RobotBuilder.vue?vue&type=script&lang=js&"
export * from "./RobotBuilder.vue?vue&type=script&lang=js&"
import style0 from "./RobotBuilder.vue?vue&type=style&index=0&id=82750640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82750640",
  null
  
)

export default component.exports